$(document).ready(function () {
    const scrollToTop = $('.scrollToTop');
    const btnScrollTo = $('#btnScrollTo');

    scrollToTop.on('click', function (event) {
        $('html, body').animate({
            scrollTop: $("body").offset().top
        }, 1000);
    });

    $(window).scroll(function () {
        var wH = $(window).height(),
            wS = $(this).scrollTop();

        if (wS >= wH) {
            btnScrollTo.addClass('show');
        } else {
            btnScrollTo.removeClass('show');
        }
    });


    /**
     * VideoJS
     * show button 2 minutes after video starts
     */
    if ($('#proPlantVSL').length) {
        videojs('proPlantVSL').ready(function () {
            this.on('timeupdate', function () {
                if (this.currentTime() >= (60 * 1) || this.currentTime() == this.duration()) {
                    $('.vslSection .btn').removeClass('invisible');
                }
                // console.log(this.currentTime());
            })
        });
    };

    /**
     * Offer stamp animation
     * gets the data-stamp attr and duplicates it to create the shadow under the animation
     */
    if ($('#offerStamp').length) {
        const thisElement = $('#offerStamp');
        const offerText = thisElement.html();
        thisElement.append('<span class="offer-stamp__text">' + offerText + '</span>')
    }

    /**
     * Scroll to Cart
     */
    const salesBanner = $('#salesBanner');
    const timeSensitiveBanner = $('#timeSensitiveBanner');

    if ($(salesBanner).length) {
        let salesBannerHeight = Math.floor($('#salesBanner').outerHeight());

        if ($('#salesBanner').hasClass('isSticky')) {

            $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top - salesBannerHeight
                }, 1000);
            });
        } else {
            $('#salesBanner, .btn:not(.cta)').on('click', function (event) {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top
                }, 1000);
            });
        }
    } else if (timeSensitiveBanner.length) {
        $('#timeSensitiveBanner, .btn:not(.cta)').on('click', function (event) {
            let timeSensitiveBannerHeight = Math.floor($('#timeSensitiveBanner').outerHeight());

            if ($('body').hasClass('show-timeSensitiveBanner')) {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top - timeSensitiveBannerHeight
                }, 1000);
            } else {
                $('html, body').animate({
                    scrollTop: $("#orderNow").offset().top
                }, 1000);
            }
        });

    } else {
        $('.btn:not(.cta), #giveAwayBanner').on('click', function (event) {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top
            }, 1000);
        });
    }

    // Add alert 
    $('.cta-wrap').on('click', function () {
        if ($('#cartCta').hasClass('disabled')) {
            $(".subscribe-box__alert").addClass('show');
            $("#subscribeCheckbox").addClass('alert');
        }
    })

    /**
     * Handle products
     */
    const
        body = $('body'),
        disclaimerBox = $('#disclaimerBox'),
        disclaimerTrigger = $('#disclaimerTrigger'),
        subscribeMode = $('.purchaseMode'),
        subscribeModeDoubleSS = $('#subscribeModeDoubleSS');

    //- Select Subscribe option if click on disclaimer box title
    disclaimerTrigger.on("click", function () {
        let checkbox = $('#subscribeCheckbox');
        let cartBtn = $('#cartCta');

        checkbox.toggleClass('checked');
        cartBtn.toggleClass('disabled');

        if (checkbox.hasClass('alert')) {
            $('.subscribe-box__alert').removeClass('show');
            checkbox.removeClass('alert');
        }
    });

    // close disclaimer box
    $('#closeDisclaimer').on('click', function () {
        disclaimerBox.removeClass('subscribe-box__disclaimer--open');
    });

    // Select Product Option - extended functionality to switch between products
    $('.product-switch__option').on('click', function () {
        let thisProduct = $(this);
        let thisProductAttr = thisProduct.attr('data-product-option');

        if (!thisProduct.hasClass('active')) {
            $('.product-switch__option').removeClass('active');
            thisProduct.addClass('active');
        }

        //- assign the chosen product attr to its parent
        thisProduct.parent().attr('data-product', thisProductAttr);

        $('.cart__product.active').trigger("click");
    })

    // Subscribe Mode
    $('.subscribe-box__default').on('click', function () {
        let thisBtn = $(this);
        let cartBtn = $('#cartCta');
        let checkbox = $('#subscribeCheckbox');

        $('.subscribe-box__default').removeClass('active');
        thisBtn.addClass('active');

        disclaimerBox.addClass('subscribe-box__disclaimer--open');

        //- reset all UIs
        if (cartBtn.hasClass('disabled')) {
            cartBtn.removeClass('disabled');
        }

        if (checkbox.hasClass('checked')) {
            checkbox.removeClass('checked');
        }

        //- set 'data-subscribe' value + control UI
        if (thisBtn.hasClass('subscribe')) {
            subscribeMode.attr('data-subscribe', 'true');

            if (!cartBtn.hasClass('disabled')) {
                cartBtn.addClass('disabled');
            }

            if (!disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
                disclaimerBox.addClass('subscribe-box__disclaimer--open');
            }

        } else {
            subscribeMode.attr('data-subscribe', 'false');

            if (cartBtn.hasClass('disabled')) {
                cartBtn.removeClass('disabled');
            }

            if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
                disclaimerBox.removeClass('subscribe-box__disclaimer--open');
            }
        }

        $('.cart__product.active').trigger("click");
    });

    /**
     * Subscribe Mode - chechbox mode
     */
    $('#subscribeInput').on('click', function (check) {
        // console.log($(this).is(":checked"));

        let checkboxType;

        if ($('#orderNow').attr('data-subscribe') === 'false') {
            checkboxType = true;

            subscribeOn();

            if (ctaSubscribeAndSaveText != '') {
                $('#cartCta').html(ctaSubscribeAndSaveText);
            }

            if (subscribeModeDoubleSS.length) {
                $('#cartCta').addClass('disabled');
            }

        } else {
            checkboxType = false;

            subscribeOff();

            if (ctaSubscribeAndSaveText != '') {
                const htmlToRender = promotionText != '' ? `${ctaText}<span class='cta-btn__promoText'>${promotionText}</span>` : ctaText;
                $('#cartCta').html(htmlToRender);
            }

            if (subscribeModeDoubleSS.length) {
                $('#cartCta').removeClass('disabled');

                //- Reset S&S click on disable alert
                if ($('#subscribeCheckbox').hasClass('alert')) {
                    $(".subscribe-box__alert").removeClass('show');
                    $("#subscribeCheckbox").removeClass('alert');
                }

                if ($('#subscribeCheckbox').hasClass('checked')) {
                    $("#subscribeCheckbox").removeClass('checked');
                }
            }
        }

        this.setAttribute('checked', checkboxType);

        $('.cart__product.active').trigger("click");
    });

    $('#stateSSOn').on('click', function (check) {
        subscribeOn();

        $('#subscribeInput').attr('checked', 'true');

        $('.cart__product.active').trigger("click");
    })

    function subscribeOn() {
        $('#orderNow').attr('data-subscribe', 'true');
        subscribeMode.attr('data-subscribe', 'true');
        disclaimerBox.addClass('subscribe-box__disclaimer--open');
    }

    function subscribeOff() {
        $('#orderNow').attr('data-subscribe', 'false')
        subscribeMode.attr('data-subscribe', 'false');

        // on touch screens
        if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.removeClass('subscribe-box__disclaimer--open');
        }
    }

    function activeProduct() {
        let thisProduct = $(this);
        let subscribeAttr = $('.purchaseMode').attr('data-subscribe');
        let chooseProductAttr = $('#chooseProduct').attr('data-product');

        const retail = thisProduct.attr('data-retail');

        let price,
            regularity,
            link,
            shipping,
            alternativeContentValue,
            timeSensitiveBannerContentValue,
            badge,
            timeSensitiveBanner,
            unit = thisProduct.attr('data-units');

        if (thisProduct.attr('data-stamp')) {
            badge = thisProduct.attr('data-stamp');
        }

        if ($('#chooseProduct').length && chooseProductAttr === 'optional') {
            if (subscribeAttr === 'true') {
                link = 'data-option-subscribe-tracker';

            } else {
                link = 'data-option-tracker';
            }

            $('.cart__image-default').removeClass('show').addClass('hide');
            $('.cart__image-optional').removeClass('hide').addClass('show');

        } else {
            if (subscribeAttr === 'true') {
                link = 'data-subscribe-tracker';

            } else {
                link = 'data-tracker';
            }$(body).hasClass

            $('.cart__image-default').removeClass('hide').addClass('show');
            $('.cart__image-optional').removeClass('show').addClass('hide');
        }

        if (subscribeAttr === 'true') {
            price = 'data-subscribe-amount';
            regularity = '<span>/month</span>';
            shipping = 'data-subscribe-shipping';
            alternativeContentValue = '';

            // $('.current__value').html(thisProduct.attr(price) + '<span>/month</span>');

        } else {
            price = 'data-amount';
            regularity = '';
            shipping = 'data-shipping';
            alternativeContentValue = $('#alternativeContent').attr('data-alt-content');

            // $('.current__value').html(thisProduct.attr(price));
        }

        if ($(body).hasClass('show-timeSensitiveBanner')) {
            timeSensitiveBanner = '-timeSensitiveBanner';
            timeSensitiveBannerContentValue = $('#timeSensitiveBannerContent').attr('data-time-sensitive-content');
            shipping = 'data-shipping-time-sensitive';
        } else {
            timeSensitiveBanner = ''
            timeSensitiveBannerContentValue = $('#timeSensitiveBannerContent').attr('data-time-sensitive-content-off');
        }

        $('.cart__product').removeClass('active');
        thisProduct.addClass('active');

        //- Support to animate 
        if ($('#productSwitch').length) {
            $('#productSwitch').removeClass(function (index, className) {
                return (className.match(/(^|\s)unit\S+/g) || []).join(' ');
            }).addClass('unit' + unit);
        }

        $('.current__value').html(thisProduct.attr(price) + regularity);
        $('.retail__value').html(retail);

        // $('.shipping__value').html((thisProduct.attr(shipping)) + ' ');
        
        if($('.cart__summary--timeSensitive').length) {
            let timeSensitiveShipping = thisProduct.attr(shipping),
                timeSensitiveShippingFirstChar = timeSensitiveShipping.charAt(0),
                timeSensitiveShippingRemoveFirstChar = timeSensitiveShipping.substring(1);

            if(timeSensitiveShippingFirstChar == '-') {
                $('.shipping__value').addClass('shipping__value--neg');

            } else {
                $('.shipping__value').removeClass('shipping__value--neg');
            }

            $('.shipping__value').html(timeSensitiveShippingRemoveFirstChar);
            
        } else {
            $('.shipping__value').html((thisProduct.attr(shipping)) + ' ');
        }

        $('#alternativeContent').html(' ' + alternativeContentValue);

        //- When time sensitive banner promo
        $('#timeSensitiveBannerContent').html(timeSensitiveBannerContentValue);

        //- TECH-2164 - Remove Shipping
        // if (unit == '3' || unit == '6' || unit == '1' && subscribeAttr === 'true') {
        //     if (!$('.shipping').hasClass('hide')) {
        //         $('.shipping').addClass('hide');
        //     }
        // } else {
        //     $('.shipping').removeClass('hide');
        // }

        $('.saving__value').html((retail - thisProduct.attr(price)).toFixed(2));

        // Images to show according to the product unit
        $('.cart__image-item').removeClass('show').addClass('hide');
        $('.cart__image-item--' + unit + "").removeClass('hide').addClass('show');

        //- prints Best value per package
        if ($('#ribbon').length) {
            $('.ribbon__value').html(badge);
        }

        //- handle CTA by ID
        adjustUtmContent();

        let param = $('#cartCta').attr('data-param');
        $('#cartCta').attr('href', thisProduct.attr(link + timeSensitiveBanner) + param);

        showNotificationByProductOption();
    }

    function showNotificationByProductOption() {
        const thisNotification = $('#notification');
        let thisNotificationAttr = thisNotification.attr('data-flavor');
        let chooseProductAttr = $('#chooseProduct').attr('data-product');

        // console.log('typeof notificationShowForFlavor', typeof notificationShowForFlavor);
        
        if(typeof notificationShowForFlavor !== 'undefined') {
            // console.log('thisNotificationAttr', thisNotificationAttr);
            // console.log('notificationShowForFlavor', notificationShowForFlavor);
            // console.log('chooseProductAttr', chooseProductAttr);

            if (thisNotificationAttr === notificationShowForFlavor && chooseProductAttr === notificationShowForFlavor ) thisNotification.removeClass('hide')
            else thisNotification.addClass('hide')
        }
    }

    $('.cart__product').on('click', activeProduct);
    $('.cart__product.active').trigger("click");

    /**
     * Reviews Slick
     */
    $('#reviewsList').slick({
        slidesToShow: 1,
        arrows: true,
        dots: true,
        speed: 700,
        adaptiveHeight: true,
        centerMode: false
    });

    /**
     * Handle Video instances Play/Pause
     */
    // Create array for player IDs
    let players = [];

    // Determine the available player IDs
    for (let i = 0; i < Object.keys(videojs.players).length; i++) {
        // Assign the player name to setPlayer
        var setPlayer = Object.keys(videojs.players)[i];

        // Define the ready event for the player
        videojs.getPlayer(setPlayer).ready(function () {
            // Assign this player to a variable
            let myPlayer = this;

            //- Assign Slick controls to a variable
            let slickArrow = $('.slick-arrow');
            let slickDots = $('.slick-dots li');

            // Assign and event listener for play event
            myPlayer.on("play", onPlay);

            slickArrow.on("click", onPlay);
            slickDots.on("click", onPlay);

            // Push the player to the players array
            players.push(myPlayer);
        });
    }

    // Handle all players' play event 
    function onPlay(e) {
        // Determine which player the event is coming from
        var id = e.target.id;

        // Loop through the array of players
        for (let x = 0; x < players.length; x++) {
            // Get the player(s) that did not trigger the play event
            if (players[x].id() != id) {
                // Pause the other player(s)
                videojs(players[x].id()).pause();
            }
        }
    }

    /**
     * product Images Carousel Slick
     */
    if ($('.style1 #productImagesCarousel').length) {
        $('#productImagesCarousel').slick({
            slidesToShow: 1,
            arrows: true,
            dots: true,
            speed: 700,
            adaptiveHeight: false,
            centerMode: false,
            infinite: true
        });
    }
    if ($('.style2 #productImagesCarousel').length) {
        $('#productImagesCarousel').slick({
            slidesToShow: 1,
            arrows: false,
            dots: false,
            speed: 700,
            autoplay: true,
            autoplaySpeed: 4000,
            adaptiveHeight: false,
            infinite: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        centerMode: true
                    }
                }
            ]
        });
    }
    
    if ($('.style3 #productImagesCarousel').length) {
        $('#productImagesCarousel').slick({
            slidesToShow: 1,
            arrows: false,
            dots: false,
            speed: 700,
            adaptiveHeight: false,
            centerMode: false,
            asNavFor: '#productImagesNav',
            infinite: true
        });
    }

    if ($('#productImagesNav').length) {
        $('#productImagesNav').slick({
            slidesToShow: 3.5,
            slidesToScroll: 1,
            asNavFor: '#productImagesCarousel',
            focusOnSelect: true,
            arrows: false,
            mobileFirst: true,
            infinite: false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 4.5
                }
              }
            ]
        });
    }

    // Play - Pause btn
    $('.pauseBtns .pause').on('click', function () {
        $('.pauseBtns .pause').removeClass('show').addClass('hide');
        $('.pauseBtns .play').removeClass('hide').addClass('show');
        $('.style2 #productImagesCarousel')
            .slick('slickPause')
    });

    $('.pauseBtns .play').on('click', function () {
        $('.pauseBtns .play').removeClass('show').addClass('hide');
        $('.pauseBtns .pause').removeClass('hide').addClass('show');
        $('.style2 #productImagesCarousel')
            .slick('slickPlay')
    });


    //- handle Modal > load / show correct image
    $('#imageModal').on('show.bs.modal', function (event) {
        let eventTrigger = $(event.relatedTarget); // Button that triggered the modal
        let mediaSrc = eventTrigger.attr('src'); // Extract img src
        let mediaAlt = eventTrigger.attr('alt'); // Extract info from data-* attributes

        let modal = $(this)

        $('body').addClass('productImagesCarousel');
        modal.find('.modal-body img').attr("src", mediaSrc).attr("alt", mediaAlt);
    });

    $('#imageModal').on('hidden.bs.modal', function (event) {
        $('body').removeClass('productImagesCarousel');
    });

    /**
     * Product Benefits bullets
     */

    let num = 0;
    function timeoutDotsAnimation() {
        setTimeout(function () {
            const el = $('#benefitsListAnimated .healthBenefits__item');
            // console.log('num', num);
            (num === 5) ? num = 1 : num++;

            el.removeClass('healthBenefits__item--anim');
            $('#benefitsListAnimated .healthBenefits__item[data-num=' + num + ']').addClass('healthBenefits__item--anim');
            timeoutDotsAnimation();
        }, 3000);
    }

    if ($('#benefitsListAnimated').length) {
        timeoutDotsAnimation();
    }

    //- Set current Year to footer Copyright
    let thisDate = new Date();
    $('#year').html(thisDate.getFullYear());

    /**
     * sc_popscreen
     */
    function smoothScrollToValue(top, left) {
        window.scrollTo({
            top: top, //- number
            left: left,//- number
            behavior: 'smooth'
        });
    }

    function showPopScreen() {
        $('.popscreen').show();
        $('body').addClass('noscroll');

        smoothScrollToValue(0, 0);
    }

    function hidePopScreen() {
        $('.popscreen').hide();
        $('body').removeClass('noscroll');
    }

    if ($('#orderNow').length > 0) {
        $('[data-close]').on('click', hidePopScreen);
    }

    if ($('.popscreen').length > 0) {
        if (usePopupCookies == true) {
            if (!$.cookie('popupWelcomeVisited')) {
                showPopScreen()
                $.cookie("popupWelcomeVisited", 1, { expires: 60 * 19.43 });

            } else {
                if ($('#orderNow').length > 0) {
                    hidePopScreen()
                }
            }

        } else {
            showPopScreen()
        }
    }

    /**
     * Time Sensitive Banner
     * ------------------------------------------
     * Add Duration Cookie with 15min expiration
     * Add Reset Cookie to show the banner again
     * Start countdown
     * calc countdown if page reload and restart it
     */

    if (timeSensitiveBanner.length) {
        let durationExpires = new Date(new Date().getTime() + durationMinutes * 60 * 1000); //- minutes
        let resetTimeExpires = new Date(new Date().getTime() + resetTimeHours * 60 * 60 * 1000); //- hours
        // let resetTimeExpires = new Date(new Date().getTime() + resetTimeHours * 60 * 1000); //- minutes to easily test the feature
        let timeSensitiveBannerStart = new Date(new Date().getTime()).toUTCString();
        let timeSensitiveBannerDuration = durationExpires.toUTCString();
        
        // console.log('now Date', new Date(new Date().getTime()));
        // console.log('durationMinutes', durationMinutes);
        // console.log('durationExpires', durationExpires);
        // console.log('resetTimeHours', resetTimeHours);
        // console.log('resetTimeExpires', resetTimeExpires);
        // console.log('timeSensitiveBannerStart', timeSensitiveBannerStart);
        // console.log('timeSensitiveBannerDuration', timeSensitiveBannerDuration);

        //- Support different pages with different durations
        let timeSensitiveBannerDurationCookie = 'timeSensitiveBannerDurationFor' + durationMinutes + 'min',
            timeSensitiveBannerResetCookie = 'timeSensitiveBannerResetFor' + durationMinutes + 'min',
            timeSensitiveBannerNewStartCookie = 'timeSensitiveBannerNewStartFor' + durationMinutes + 'min';

        // console.log('timeSensitiveBannerDurationCookie ' + timeSensitiveBannerDurationCookie);
        // console.log('timeSensitiveBannerResetCookie ' + timeSensitiveBannerResetCookie);
        // console.log('timeSensitiveBannerNewStartCookie ' + timeSensitiveBannerNewStartCookie);

        smoothScrollToValue(0, 0);

        /**
         * 1. Re-run countdown if reload page within duration on based on diff calculation
         * 
         * 2. Add cookies duration and reset and storage current time if cookies doesn't exist
         * 
         * 3. Remove local storage with starting time if duration expired but reset didn't yet 
         */
        if ($.cookie(timeSensitiveBannerDurationCookie) && $.cookie(timeSensitiveBannerResetCookie)) {
            localStorage.setItem(timeSensitiveBannerNewStartCookie, timeSensitiveBannerStart);

            let calcDiffTime = {
                newStart: localStorage.getItem(timeSensitiveBannerNewStartCookie),
                duration: localStorage.getItem(timeSensitiveBannerDurationCookie)
            }
            
            // console.log('>> timeSensitiveBannerNewStart', calcDiffTime.newStart, Date.parse(calcDiffTime.newStart));
            // console.log('>> timeSensitiveBannerDuration', calcDiffTime.duration, Date.parse(calcDiffTime.duration));

            let diffTime = (Date.parse(calcDiffTime.duration) - Date.parse(calcDiffTime.newStart)),

                diffMinutes = Math.floor((diffTime / 1000 / 60) % 60),
                diffSeconds = Math.floor((diffTime / 1000) % 60);

            // console.log('>> diffTime', diffTime);
            // console.log('>> diffMinutes', diffMinutes);
            // console.log('>> diffSeconds', diffSeconds);

            setActiveTimer(diffMinutes, diffSeconds);
            
            $('.cart__product.active').trigger("click");

        } else if (!$.cookie(timeSensitiveBannerDurationCookie) && !$.cookie(timeSensitiveBannerResetCookie)) {
            setActiveTimer(durationMinutes, 0);

            $('.cart__product.active').trigger("click");

            $.cookie(timeSensitiveBannerDurationCookie, 1, { expires: durationExpires });
            $.cookie(timeSensitiveBannerResetCookie, 1, { expires: resetTimeExpires });

            localStorage.setItem(timeSensitiveBannerDurationCookie, timeSensitiveBannerDuration);

        } else if (!$.cookie(timeSensitiveBannerDurationCookie) && $.cookie(timeSensitiveBannerResetCookie)) {
            localStorage.removeItem(timeSensitiveBannerDurationCookie);
            localStorage.removeItem(timeSensitiveBannerNewStartCookie);

        }

        /**
         * Change Layout on Scroll
         */
        function adjustHeader() {
            const bannerHeight = timeSensitiveBanner.outerHeight();

            if ($(window).scrollTop() > bannerHeight) {
                $(".timeSensitiveBanner:not(.timeSensitiveBanner--compact)").addClass("timeSensitiveBanner--compact");

            } else if ($(window).scrollTop() < 200) {
                $(".timeSensitiveBanner").removeClass("timeSensitiveBanner--compact");

            }

            const appearingStickyBanner = $('.productBanner--appearing');
            
            if (appearingStickyBanner.length > 0) {
                const blockOffset = appearingStickyBanner.offset().top + appearingStickyBanner.outerHeight();

                if ($(window).scrollTop() > blockOffset) {
                    appearingStickyBanner.addClass("productBanner--compact");
                } else if ($(window).scrollTop() < appearingStickyBanner.offset().top) {
                    appearingStickyBanner.removeClass("productBanner--compact");
                }
            }
        }

        adjustHeader();

        $(window).on('scroll', adjustHeader);
    }

    function vslSectionHeight(parentId) {	
        let vslSectionHeight = Math.floor($(parentId).outerHeight());
        document.documentElement.style.setProperty('--vslSectionHeight', vslSectionHeight + 'px');
    }

    if ($('#socialProofBanner + #testimonials').length) {
        let testimonialsVideo = $('#testimonials .video');
    
        vslSectionHeight(testimonialsVideo);
    
        //- seTimeout for window resizing
        let resizeTimer;
    
        $(window).on('resize', function(e) {
            clearTimeout(resizeTimer);
    
            resizeTimer = setTimeout(function() {
                vslSectionHeight(testimonialsVideo);
            }, 250);
    
        });
    }

    if ($('#socialProofBanner + #watch').length) {
        let vslSection = $('#watch .video');
    
        vslSectionHeight(vslSection);
    
        //- seTimeout for window resizing
        let resizeTimer;
    
        $(window).on('resize', function(e) {
            clearTimeout(resizeTimer);
    
            resizeTimer = setTimeout(function() {
                vslSectionHeight(vslSection);
            }, 250);
    
        });
    }

    /**
     * Social Proof Users Carousel
     */
    if($('#socialProofList').length) {
        $('#socialProofList').slick({
            mobileFirst: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            speed: 700,
            centerMode: true,
            autoplay: true,
            autoplaySpeed: 2000,
            centerPadding: '30px',
            responsive: [
                {
                    breakpoint: 430,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 570,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 6
                    }
                },
                {
                    breakpoint: 945,
                    settings: {
                        slidesToShow: 7,
                        centerPadding: '60px'
                    }
                }
            ]
        });
    }

    //- Gets product image height and saves it as CSS variable
    function topSectionProductHeight() {
        if ($('.topSection__img').length) {
            document.documentElement.style.setProperty('--topSectionProductHeight', "".concat($('.topSection__img').outerHeight(), "px"));
        } else {
            document.documentElement.style.setProperty('--topSectionProductHeight', "".concat($('.topSection').outerHeight(), "px"));
        }
    };

    topSectionProductHeight(); 

    let tsBannerHeight = 0;
    function timeSensitiveBannerHeight() {
        tsBannerHeight = $('#timeSensitiveBanner').outerHeight();
        document.documentElement.style.setProperty('--timeSensitiveBannerHeight', "".concat(tsBannerHeight, "px"));
    }
    
    
    if ($('#timeSensitiveBanner').is(":visible")) {
        timeSensitiveBannerHeight();
        /**
         * We have to update the variable on scroll because the banner height can change
         */
        document.addEventListener('scroll', function(){
            if ($('#timeSensitiveBanner').outerHeight() !== tsBannerHeight) {
                timeSensitiveBannerHeight();
            }
        });
    } else {
        document.documentElement.style.setProperty('--timeSensitiveBannerHeight', "".concat("0px"));
    }

    $('.topSection__cta').on('click', function(e) {
        const shift = 25;
        $('html, body').animate({
            scrollTop: $("#orderNow").offset().top - shift - tsBannerHeight
        }, 1000);
    });

    const bars = document.querySelectorAll('.infographic__bar[data-amount]');

    function animateProgressBar() {
        bars.forEach(bar => {   
            const scrollPosition = window.scrollY + window.innerHeight;
            const barPosition = bar.offsetTop + bar.offsetHeight;
          
            const amount = bar.getAttribute('data-amount').replace(/[^\d]/g, '');
            const maxSize = 100; 
            const filledSize = (amount / 15) * maxSize; 

            if (scrollPosition >= barPosition) {
                if (document.querySelector(".infographic__info-section").classList.contains("infographic__info-section--vertical")) bar.style.height = `${filledSize}%`
                else bar.style.width = `${filledSize}%`
                bar.classList.add('infographic__bar--fill');
            }
        });
    }
      
    window.addEventListener('scroll', animateProgressBar);

    // Manipulate UTM to pass answer from survey passed as fw_survey
    const updateUTMPersonalizedContentSurvey = () => {
        if (window.location.href.includes('fw_survey') && typeof originalUtmContent !== 'undefined') {
            const search = window.location.search;
    
            //- Split window.location.search on '&' to get array of all params
            const searchSplit = search.split('&');
    
            //- Filter and storage 'fw_survey' from all indices from array
            const answers = searchSplit.filter((answer) => answer.startsWith("fw_survey"));
    
            //- Convert answers to string to get only answers and pop from param Name
            const getAnswers = answers.toString().split('=').pop();
            // console.log('getAnswers', getAnswers)
    
            const splitAnswers = getAnswers.split('_');
            // console.log('splitAnswers', splitAnswers); // eg: describeyou1
    
            /**
             * Update utm_content if user clicked on any answer
             * _qs-pp-yt-ecom_v03_fnSurveyPersonalizedContentV02-opt_n -> _qs-pp-yt-ecom_v03_fwSurvey-describeyou1_fnSurveyPersonalizedContentV02-opt_n
             * _qs-pp-yt-ecom_v03_fnSurveyPersonalizedContentV02-opt_y_XX -> _qs-pp-yt-ecom_v03_fwSurvey-describeyou1_fnSurveyPersonalizedContentV02-opt_y_XX
             */
            const utmContentSplit = originalUtmContent.split('_'); //- array can have a length of 5 or 6 indexes, depending on opt_n or opt_y_XX
            // console.log('utmContentSplit', utmContentSplit);
            // console.log('utmContentSplit[3]', utmContentSplit[3]);
    
            let newUtmContent = '';
    
            //- Define new utm_content based on array.length
            if(utmContentSplit.length == 6) {
                newUtmContent = '_' + utmContentSplit[1] + '_' + utmContentSplit[2] + '_fwSurvey-' + splitAnswers + '_' + utmContentSplit[3] + '_' + utmContentSplit[4] + '_' + utmContentSplit[5];
    
            } else {
                newUtmContent = '_' + utmContentSplit[1] + '_' + utmContentSplit[2] + '_fwSurvey-' + splitAnswers + '_' + utmContentSplit[3] + '_' + utmContentSplit[4];
            }
    
            // console.log('newUtmContent', newUtmContent);
    
            //- Update data-param and href CTA
            $('[data-param]').each(function(index){
                const paramTargetPrefix = $(this).attr('data-param').split('utm_content=')[0];
                $(this).attr('data-param', `${paramTargetPrefix}utm_content=${newUtmContent}`);
    
                const hrefTargetPrefix = $(this).attr('href').split('utm_content=')[0];
                $(this).attr('href', `${hrefTargetPrefix}utm_content=${newUtmContent}`);
            });
        }
    }

    updateUTMPersonalizedContentSurvey();
});
